import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const messages = ["Analyzing word choice...", "Analyzing pacing...", "Analyzing tone...", "Analyzing structure...", "Analyzing descriptions..."];
const messageVariant = {
  hidden: {
    y: 50,
    opacity: 0,
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    y: -50,
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};

export function WordScrollBox() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        className="word-scroll-box"
        key={index}
        variants={messageVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {messages[index]}
      </motion.div>
    </AnimatePresence>
  );
}
